// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetDistrictDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import DistrictDTO from '../models/DistrictDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
    academicYear: number | null | null;
    districtId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
            academicYear: null,
            districtId: null,
        },
        initValues);
    },
    id: 'id',
    academicYear: 'academicYear',
    districtId: 'districtId',
}

interface Result extends ResultDTO {
    district: DistrictDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            district: null,
        },
        initValues);
    },
    district: 'district',
}

export { Request, Result };